export default __webpack_public_path__ + "static/media/kk.6ddae3bc.svg";